import { render, staticRenderFns } from "./SmsInput.vue?vue&type=template&id=63e6d11a&scoped=true"
import script from "./SmsInput.vue?vue&type=script&lang=js"
export * from "./SmsInput.vue?vue&type=script&lang=js"
import style0 from "./SmsInput.vue?vue&type=style&index=0&id=63e6d11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6d11a",
  null
  
)

export default component.exports